var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { Notification } from '../../../../components/Notification';
import { DefaultContentStep } from '../../../../components/DefaultContentStep';
import { HandleError } from '../../../utils/HandleError';
import { RequerimentosApi } from '../../../../apis/requerimento-api';
import { DefaultContent } from '../../../../components/DefaultContent';
import { ShowContent } from '../../../../components/ShowContent';
import { ConfirmacaoAnexos } from './ConfirmacaoAnexos';
import { DefaultCard } from '../../../../components/DefaultCard';
import { Grid, Typography } from '@mui/material';
import { filterRenderChecklist } from '../RequerimentoCadastroRoot';
export var QuintaAbaRequerimento = function (_a) {
    // region Constants
    var _b;
    var setActiveStep = _a.setActiveStep, requerimento = _a.requerimento, onValidate = _a.onValidate;
    var _c = useState({ severity: 'info', open: false, message: '' }), notification = _c[0], setNotification = _c[1];
    var _d = useState(null), checklistView = _d[0], setChecklistView = _d[1];
    var _e = useState(null), checklist = _e[0], setChecklist = _e[1];
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = useState(undefined), error = _g[0], setError = _g[1];
    var _h = useState([]), indexViewed = _h[0], setIndexViewed = _h[1];
    // endregion
    // region Hooks
    var files = useMemo(function () {
        var _a, _b;
        return (_b = ((_a = checklist === null || checklist === void 0 ? void 0 : checklist.sessoes) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.map(function (sessao) { return sessao; }).flatMap(function (sessao) { var _a; return ((_a = sessao === null || sessao === void 0 ? void 0 : sessao.itens) !== null && _a !== void 0 ? _a : []); }).filter(function (item) { return !!(item === null || item === void 0 ? void 0 : item.arquivoBase64) || !!(item === null || item === void 0 ? void 0 : item.anexos); });
    }, [checklist === null || checklist === void 0 ? void 0 : checklist.sessoes]);
    var show = useMemo(function () {
        return (files === null || files === void 0 ? void 0 : files.length) === 0;
    }, [files === null || files === void 0 ? void 0 : files.length]);
    useEffect(function () {
        handleLoadChecklist();
    }, []);
    useEffect(function () {
        onValidate === null || onValidate === void 0 ? void 0 : onValidate(handleValidate);
    }, [indexViewed, requerimento, show]);
    useEffect(function () {
        var _checkView = filterRenderChecklist(checklist);
        setChecklistView(__assign({}, _checkView));
    }, [checklist]);
    // endregion
    // region Handlers
    var handleValidate = function () {
        var _a, _b, _c, _d, _e;
        if (show) {
            return true;
        }
        var anexos = (_e = ((_d = ((_c = (_b = ((_a = checklist === null || checklist === void 0 ? void 0 : checklist.sessoes) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.flatMap(function (it) { var _a; return ((_a = it.itens) !== null && _a !== void 0 ? _a : []); }).filter(function (it) { return !!it; })) !== null && _c !== void 0 ? _c : [])) === null || _d === void 0 ? void 0 : _d.flatMap(function (it) { var _a; return ((_a = it.anexos) !== null && _a !== void 0 ? _a : []); }).filter(function (it) { return !!it; }))) !== null && _e !== void 0 ? _e : [];
        var hasAllIndex = anexos === null || anexos === void 0 ? void 0 : anexos.every(function (anexo) {
            var _a;
            var podeVisualizar = handleFormatoVisualizavel((_a = anexo === null || anexo === void 0 ? void 0 : anexo.anexo) === null || _a === void 0 ? void 0 : _a.extensao);
            return (podeVisualizar ? indexViewed.includes(anexo.id) : true);
        });
        if (!hasAllIndex) {
            setNotification({
                message: 'Todos os arquivo enviados devem ser visualizados.',
                severity: 'warning',
                open: true,
                duration: 6000,
                vertical: 'top'
            });
        }
        return hasAllIndex;
    };
    var handleFormatoVisualizavel = function (extensao) {
        return !!extensao && (extensao === 'application/pdf' || extensao === 'image/png' || extensao === 'image/jpeg');
    };
    var handleLoadChecklist = function () {
        setLoading(true);
        RequerimentosApi.checklist(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id)
            .then(function (response) {
            setLoading(false);
            setChecklist(response);
        })
            .catch(function (err) {
            setLoading(false);
            setError(err);
        });
    };
    // endregion
    return (_jsxs(_Fragment, { children: [_jsx(DefaultContentStep, __assign({ title: "Confirma\u00E7\u00E3o dos Anexos", subtitle: "Confirme os anexos coletados. Clique no anexo para visualiz\u00E1-lo" }, { children: _jsxs(DefaultContent, __assign({ loading: loading }, { children: [_jsx(ShowContent, __assign({ show: !show }, { children: (_b = checklistView === null || checklistView === void 0 ? void 0 : checklistView.sessoes) === null || _b === void 0 ? void 0 : _b.map(function (sessao) {
                                return (_jsx(ConfirmacaoAnexos, { setActiveStep: setActiveStep, setIndexViewed: setIndexViewed, indexViewed: indexViewed, sessao: sessao }, sessao === null || sessao === void 0 ? void 0 : sessao.id));
                            }) })), _jsx(ShowContent, __assign({ show: show }, { children: _jsx(DefaultCard, __assign({ title: '', subTitle: '', style: { width: '100%' } }, { children: _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Typography, __assign({ className: 'card-header-title', textAlign: 'center' }, { children: "Nenhum anexo foi coletado para o tipo de servi\u00E7o selecionado." })) })) })) }))] })) })), _jsx(Notification, { props: notification, handleFormChange: setNotification }), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] }));
};
